<template>
    <div class="background" :style="{'background': 'url(' + theImage + ')'}">
        <div class="transbox">
            <div class="transboxContent">
                <h2>{{ $t('contactpersons.Header') }}</h2>
            </div>
        </div>
        <div id="image_holder" class="imageHolder">
            <kendo-datasource :page-size="18" ref="datasource1"
                              :transport-read-url="url"
                              :transport-read-data-type="'jsonp'">
            </kendo-datasource>
            <kendo-listview :data-source-ref="'datasource1'" :template="columnTemplate">
            </kendo-listview>
            <kendo-pager :data-source-ref="'datasource1'">
            </kendo-pager>
        </div>
        <div class="transbox">
            <div class="transboxContent">
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
            </div>
        </div>
    </div>

</template>

<script>
    import { EventBus } from '@/classes/eventBus.js';
    import { ListView, Pager } from '@progress/kendo-listview-vue-wrapper';
    import { DataSource } from '@progress/kendo-datasource-vue-wrapper';
    import kendo from '@progress/kendo-ui';
    import config from "@/appdata/config.json";

    export default {
        name: 'App',
        
        components: {
            'kendo-listview': ListView,
            'kendo-pager': Pager,
            'kendo-datasource': DataSource
        },
        props: {
            url: String
        },
        data: function () {
            return {
                theImage: ''
            }
        },
        mounted() {
            EventBus.$on('backgroundImageChange', image => {
                this.theImage = image;
            });
        },
        created() {
            this.url = config[0].ServiceUrl + config[0].ServiceUrlPort + "/Ansprechpartner"
        },
        methods: {
            columnTemplate(data) {
                let imageToLoad = data.Prim;
                var itemTemplate = kendo.template(
                    `<div class='contactpersonsPicture'">
                        <img src="` +
                    require("../images/contactpersons/" + imageToLoad + ".png") +
                    `" alt="#: Name # image" />
                       
                        <div class ='contactpersonsInfo'>
                            <h3>#:Name#</h3>
                            <p>#:Position#</br>
                            #:Aufgabe#</br>
                            #:Aufgabe2#</br>
                            <a href="mailto:#:EMail#">#:EMail#</a>
                            </p>
                        </div>
     </div>
                    </div>`
                );
                return itemTemplate(data);
            }
        }
    }
</script>

<style scoped>
    @import '../css/main.css';
</style>